export const INSTRUMENT_TYPE_LABEL = {
  field: "Field",
  inline: "Inline",
  field_virtual: "Virtual Field",
  inline_virtual: "Virtual Inline",
  emission_monitor: "Emission Monitor",
};
